import Vue from 'vue'
import App from './App.vue'
import { router } from "./router";

import 'amfe-flexible';

import { utils } from "./utils";
// 引入公共style
import './assets/css/normalize.css'
// 引入 axios
import './service/api'

// 提示
import toast from '@/components/toast'
Vue.use(toast);

// 挂载全局判断是否是PC
Vue.prototype.$isPc = utils.Browser.mobile

// 首页模式
Vue.prototype.$mode = 1; // 1正常模式，2其他


Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
